import React, { useCallback, useContext, useRef } from 'react'
import { throttle } from 'lodash'
import { Text } from 'oio-react'
import PropTypes from 'prop-types'
import noteStatuses from 'config/constants/noteStatuses'
import NotebookContext from 'src/libraries/contexts/Notebook'
import ThemeContext from 'src/libraries/contexts/Theme'
import Editor from 'src/components/utils/HtmlEditor'
import RichText from 'src/components/utils/RichText'
import { useUpdateNote, useRequestNoteLock } from 'src/graphql/hooks'

const NoteTextV2 = ({ note, noteStatus }) => {
   const inputRef = useRef(null)
   const { useFacingPages } = useContext(NotebookContext)
   const theme = useContext(ThemeContext)
   const { requestNoteLock } = useRequestNoteLock()
   const { updateNote } = useUpdateNote()

   const handleBlurEditor = useCallback((e) => {
      // If Esc key was pressed, blur focus
      if (e.keyCode === 27 && 'activeElement' in document) {
         document.activeElement.blur()
      }
   }, [])

   const handleContentChanged = throttle(async () => {
      const { editor } = inputRef.current

      await requestNoteLock({ id: note.id })
      updateNote({ id: note.id }, {
         content: [{
            operation: 'updateRichText',
            updateRichText: {
               body: editor.html.get(true),
               id: note.content.elements[0].id
            }
         }]
      }, { fetchPolicy: 'no-cache' })
   }, 3000)

   return (
      <Text
         size={useFacingPages ? '2.5' : theme.tmpBodyTextSize}
         lineHeight={theme.tmpBodyTextLineHeight}
         color={theme.tmpBodyTextColor}>
         {noteStatus === noteStatuses.NOTE_STATUS_LOCKED && (
            <RichText html={note.content.elements[0].body} />
         )}
         {noteStatus !== noteStatuses.NOTE_STATUS_LOCKED && (
            <Editor
               ref={inputRef}
               initialValue={note.content?.elements?.[0]?.body}
               reinitializeKey={note.id}
               onChange={handleContentChanged}
               config={{
                  events: { keypress: handleBlurEditor },
                  heightMin: 300,
                  toolbarInline: true,
                  quickInsertEnabled: true
               }}
            />
         )}
      </Text>
   )
}

NoteTextV2.propTypes = {
   note: PropTypes.object.isRequired,
   noteStatus: PropTypes.number.isRequired
}

export default NoteTextV2
